export default __webpack_public_path__ + "static/media/logo_hamburg_airport.858591f8.jpg";